import React from 'react'

import InfoPanelRow from "../ip-section-row/info-panel-row"
import FieldView from "../../fields3/render/view"
import TimeReport from "../../model2/time-report/time-report"

type Props = {
    timeReport : TimeReport
}

// The entity a time report is linked to - a task or a meeting (exactly one of them).
// Used by the time report item view and by the create-time-report modal.
export default function TimeReportEntityRow(props: Props) {

    const timeReport = props.timeReport

    if (timeReport.isMeetingReport) {
        const meeting = timeReport.meeting

        const goToMeeting = () => {
            if (!meeting) return
            gd.navigation.goToMeeting(meeting.id)
        }

        return (
            <InfoPanelRow label="Meeting">
                <div className  = "ui5-control-button-28"
                     onClick    = {goToMeeting}
                >
                    <div className="ui5-ico-16 i5-meeting flex-no-shrink m-r-10"/>
                    <div className="ui5-txt-default txt-truncate max-w-300">
                        {meeting?.name || ''}
                    </div>
                </div>
            </InfoPanelRow>
        )
    }

    const goToTask = () => {
        if (!timeReport.task) return
        gd.navigation.goToTask(timeReport.task.id)
    }

    return (
        <InfoPanelRow label="Task">
            <div className  = "ui5-control-button-28"
                 onClick    = {goToTask}
            >
                <FieldView
                    className   = "m-r-10"
                    field       = {gd.fields.task.taskTypeId}
                    model       = {timeReport.task}
                    options     = {{size:'16'}}
                />
                <FieldView
                    className   = "m-r-10 max-w-300"
                    field       = {gd.fields.task.title}
                    model       = {timeReport.task}
                />
            </div>
        </InfoPanelRow>
    )
}
